module.exports = __webpack_public_path__ + "img/edge_activites_golf.ad43577b.svg";